<div class="tile__status tile__status--universal" data-testid="tile"
     [ngClass]="{ 'tile__status--active': tile.params.statusId === 1,
         'tile__status--inactive': tile.params.statusId === 0,
         'tile__status--default': tile.params.statusId === 2 }">
    <div class="tile__svg--other-wrapper bg-img">
        <img class="tile__svg--other"
             ngSrc="{{icon.setIcon(tile.params.iconId)}}"
            width="50" height="50" alt="" />
    </div>
    <div class="tile__subtitle">
        <floating-subtitle class="tile__subtitle-row"
                           *ngIf="tile.params.widget1.txtId > 0"
                           [text]="subtitle(tile.params.widget1.txtId)">
        </floating-subtitle>
        <floating-subtitle class="tile__subtitle-row"
                           *ngIf="tile.params.widget2.txtId > 0"
                           [text]="subtitle(tile.params.widget2.txtId)">
        </floating-subtitle>
    </div>
    <div class="tile__value" *ngIf="universalTile.type == 9 ">
        <p class="tile__value-set-temp font-18 color-default color-default--tile"
           data-testid="widget1-text">
            <span *ngIf="subtitles.downloaded">
                  {{ universalTile.value1 | format:universalTile.value1Format:universalTile.value1Unit }}
            </span>
            <span *ngIf="universalTile.correctFormat > 0">
                  {{ ' (' + (universalTile.correctValue > 0
                    ? ('+' + universalTile.correctValue | format:universalTile.correctFormat)
                    : (universalTile.correctValue | format:universalTile.correctFormat)) + ')' }}
            </span>
        </p>
        <p class="tile__value-current font-24 font-bold color-style"
           data-testid="widget2-text"
           *ngIf="subtitles.downloaded">
           {{ universalTile.value2 | format:universalTile.value2Format }}
        </p>
    </div>

    <div class="tile__value tile__indicator"
        *ngIf="universalTile.type === 2">
        <circle-progress-thin [angleEnd]="universalTile.value * 3.0"></circle-progress-thin>
        <p class="tile__value-svg tile__value-svg--circle font-14"
           data-testid="tile-value"
           *ngIf="subtitles.downloaded">
           {{ universalTile.value | format:universalTile.unit }}
        </p>
    </div>

    <div class="tile__value tile__indicator"
        *ngIf="universalTile.type === 3">
        <svg width="50" height="52" class="settings-tile-svg-fill tile__svg-fill">
            <rect x="2" y="30" width="10" height="10" stroke="none"
                  [attr.fill-opacity]="universalTile.value > 0 ? 1 : 0.2">
            </rect>
            <rect x="20" y="15" width="10" height="25" stroke="none"
                  [attr.fill-opacity]="universalTile.value > 1 ? 1 : 0.2">
            </rect>
            <rect x="38" y="0" width="10" height="40" stroke="none"
                  [attr.fill-opacity]="universalTile.value > 2 ? 1 : 0.2">
            </rect>
        </svg>
        <p class="tile__value-svg tile__value-svg--bar font-10 color-style"
           data-testid="tile-value"
           *ngIf="subtitles.downloaded">
           {{ universalTile.value | format:universalTile.unit }}
        </p>
    </div>

    <div class="tile__value tile__indicator"
        *ngIf="universalTile.type === 4">
        <svg width="50" height="50">
            <circle cx="25" cy="25" r="19" fill-opacity="1"
                    class="settings-tile-svg-fill tile__svg-fill" stroke="none">
            </circle>
            <ng-container *ngFor="let point of universalTile.wheelPoints">
                <circle [attr.cx]="point.x" [attr.cy]="point.y" r="1.2"
                        class="tile.svg-fill" stroke="none">
                </circle>
            </ng-container>
        </svg>
        <p class="tile__value-svg tile__value-svg--circle color-light font-14"
           data-testid="tile-value"
           *ngIf="subtitles.downloaded">
           {{ tile.params.statusId !== 0
                ? (universalTile.value | format:universalTile.unit) : '- -' }}
        </p>
    </div>

    <div class="tile__value tile__indicator"
        *ngIf="universalTile.type === 5">
        <indicated-value
            [value]="universalTile.rotate"
            [angleEnd]="1.8 * universalTile.value">
        </indicated-value>
        <p class="tile__value-svg tile__value-svg--hand font-14"
           data-testid="tile-value"
           *ngIf="subtitles.downloaded">
           {{ universalTile.value | format:universalTile.unit }}
        </p>
    </div>

    <div class="tile__value" *ngIf="universalTile.type === 6">
        <signal-strength value="universalTile.value"></signal-strength>
    </div>

    <div class="tile__value tile__indicator" *ngIf="universalTile.type === 7">
        <svg width="50" height="50">
            <circle cx="25" cy="25" r="20" [attr.fill]="universalTile.color"
                    fill-opacity="1" [attr.stroke]="universalTile.color"
                    stroke-opacity=".5" stroke-width="8">
            </circle>
        </svg>
        <p class="tile__value-svg tile__value-svg--light font-13 color-light"
           *ngIf="subtitles.downloaded">
           {{ universalTile.value | format:universalTile.unit }}
        </p>
    </div>

    <div class="tile__value tile__indicator"
        *ngIf="universalTile.type === 8">
        <svg width="50" height="50">
            <ng-container *ngFor="let point of universalTile.graphPoints; let idx = index">
            <circle [attr.cx]="idx*11+3" [attr.cy]="30-point"
                    r="2.2" stroke="none"
                    class="settings-tile-svg-fill tile__svg-fill">
            </circle>
            </ng-container>
            <path [attr.d]="universalTile.fieldLine[0] + 'L 47,30 Z'"
                  stroke="none" class="settings-tile-svg-fill tile__svg-fill"
                  fill-opacity=".2">
            </path>
            <path [attr.d]="universalTile.fieldLine[1]"
                  class="settings-tile-svg-stroke tile__svg-stroke" fill="none">
            </path>
        </svg>
        <p class="tile__value-svg tile__value-svg--graph font-14 color-style"
           *ngIf="subtitles.downloaded">
           {{ universalTile.value | format:6 }}
        </p>
    </div>

    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
</div>
